import { useState, useEffect, useCallback } from "react";
import Grid from "../components/grid";
import Container from "../components/basicComponents/container";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import { CatalogDataProps } from "../types/public";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import { createNotificationData } from "../utils/createNotificationData";
import { addNotification } from "../state-management/actions/notification-actions";
import {
  editCatalog,
  getCatalogById,
  getCatalogs,
  removeCatalog,
} from "../state-management/actions/catalog-actions";
import CatalogComponent from "../components/catalog";

export default function CatalogList() {
  const dispatch = useDispatch();
  const { departmentsData, currentUserData, groupingData } =
    useSelector(selectGlobalState);
  const initialData: CatalogDataProps = {
    title: "",
    type: "landscape",
    designer: "",
    created_by: currentUserData._id,
    is_active: false,
    description: "",
    catalog: null,
  };
  const [catalogsData, setCatalogsData] = useState<any>([]);
  const [editFlag, setEditFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<any>({
    ...initialData,
    created_by: currentUserData._id,
  });

  const fetchData = useCallback(async () => {
    try {
      const response = await getCatalogs()(dispatch);
      console.log(response, "res");

      setCatalogsData(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(setRowStatus("clear id", false));
    fetchData();
  }, []);

  const columns: any = [
    { headerName: "عنوان کاتالوگ", field: "title", pinned: "right" },
    { headerName: "طراح", field: "designer" },
    { headerName: "انتشار", field: "is_active" },
  ];

  const handleEditSubmit = async (values: CatalogDataProps) => {
    try {
      setLoading(true);
      console.log(values, "val");
      const { _id, ...cleanData } = values;
      console.log(cleanData, "clean");
      console.log(_id, "id");
      const response = await editCatalog(_id, cleanData)(dispatch);
      if (response.data) {
        const editData = { ...cleanData, _id: _id };
        setCatalogsData((prev: any) =>
          prev.map((art: any) =>
            art._id === formData._id ? { ...art, ...editData } : art
          )
        );
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ویرایش کاتالوگ با موفقیت صورت پذیرفت"));
        dispatch(setRowStatus("clear id", false));
        setFormData({
          ...initialData,
          created_by: currentUserData._id,
        });
        setEditFlag(false);
        setLoading(false);
        const notificationData = createNotificationData({
          data: cleanData,
          departmentsData,
          currentUserData,
          groupingData,
          type: "edit",
          subject: "کاتالوگ",
        });
        await addNotification(notificationData)(dispatch);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSetEditData = async (clear: boolean, id: any) => {
    setEditFlag(clear ? false : true);
    try {
      const editData = catalogsData?.find((art: any) => art._id === id);
      const response = await getCatalogById(id)(dispatch);
      if (editData && response.data && !clear) {
        const { _id, ...data } = editData as CatalogDataProps;
        setFormData({
          ...data,
          _id: _id,
          index_picture: response.data.index_picture,
        });
      }
      if (clear) {
        setFormData({
          ...formData,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await removeCatalog(id)(dispatch);
      setCatalogsData((prev: any) =>
        prev?.filter((art: any) => art._id !== id)
      );

      dispatch(setAlert(true));
      dispatch(setAlertSeverity("success"));
      dispatch(setAlertContext(" حذف کاتالوگ با موفقیت صورت پذیرفت"));
      const notificationData = createNotificationData({
        data: catalogsData.find((item: any) => item._id === id),
        departmentsData,
        currentUserData,
        groupingData,
        type: "delete",
        subject: "کاتالوگ",
      });
      await addNotification(notificationData)(dispatch);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="لیست کاتالوگ ها">
        <Grid
          height={700}
          columns={columns}
          userData={catalogsData}
          pageSize={20}
          editable={false}
          deleteBtn={true}
          editBtn={true}
          publishBtn={false}
          pagination={true}
          btnHeader="عملیات"
          handleDelete={handleDelete}
          handleSetData={handleSetEditData}
        />
      </Container>
      <div
        className="flex flex-col items-center w-full"
        style={{ display: editFlag ? "block" : "none" }}
      >
        <Container header="ویرایش">
          <CatalogComponent
            handleSubmit={handleEditSubmit}
            formData={formData}
            setFormData={setFormData}
            currentUserId={currentUserData._id}
            loading={loading}
          />
        </Container>
      </div>
    </div>
  );
}
